import { makeAutoObservable } from 'mobx';

class ReferralDirectoryState {
  history;

  constructor() {
    makeAutoObservable(this, {
      history: false
    });
  }

  receiveProps({history}) {
    this.history = history;
  }

  goToCandidateCreation(position) {
    this.history.push(`/${position.id}/refer_candidate`);
  }
}

export default ReferralDirectoryState;
